import { CoverpathUtils } from '../../../../../../js/static/CoverpathUtils';
import { Utils } from '../../../../../../../common/js/Utils';

export class CirClaimIllustration {
  static getCirClaimIllustration(cirClaimIllustrationResponse, startIndex: number, noOfRows: number): string {
    const tabularValues = this.getTable(cirClaimIllustrationResponse, startIndex, noOfRows);
    return tabularValues;
  }

  static getTable(cirClaimIllustrationResponse, startIndex: number, noOfRows: number): string {
    const tableHtml =
      '<TABLE id="illustration-table">' +
      columnHeaderDef +
      this.getRows(cirClaimIllustrationResponse, startIndex, noOfRows) +
      '</TABLE>';
    return tableHtml;
  }

  static getRows(cirClaimIllustrationResponse, startIndex: number, noOfRows: number) {
    const rowBreakPoint = 5; //After every 5th row add a blank row
    let rows = '';
    let count = 0;

    const cirClaimIllustrationList =
      cirClaimIllustrationResponse.data.cirClaimIllustration.payload.policy.illustrationList;
    noOfRows =
      startIndex + noOfRows < cirClaimIllustrationList.length ? startIndex + noOfRows : cirClaimIllustrationList.length;

    for (let i = startIndex; i < noOfRows; i++) {
      let row = count % 2 === 0 ? `<TR class="odd-row">` : `<TR>`;
      if (columnHeaderMap) {
        columnHeaderMap.map((columnName, cellCount) => {
          const cellValue = cirClaimIllustrationList[i][columnName]
            ? Utils.formatNumber(Utils.roundAwayFromZero(cirClaimIllustrationList[i][columnName], 0), 0)
            : 0;
          if (count === rowBreakPoint) {
            row += `<TD><p>&nbsp;</p></TD>`;
          } else {
            row += `<TD><p> ${cellValue} </p></TD>`;
          }
        });
      }
      if (count === 5) {
        count = 0;
        i--;
      } else {
        count++;
      }
      row += `</TR>`;
      rows += row;
    }
    return rows;
  }

  static getFooter() {
    return `<div class="footer-text">
              <p class="p-left footer-text-bold">
              *This illustration reflects non-guaranteed values including dividends, which are neither estimates nor guarantees, but are based on the ${CoverpathUtils.getCurrentRateYear()} dividend schedule. The dividend schedule is reviewed annually and it is likely that dividends in future years will be lower or higher depending on the Company’s actual experience. For this reason, we strongly recommend that you look at a hypothetical lower schedule illustration available upon request.</p>
            </div>`;
  }
}

const columnHeaderMap = [
  'policyYear',
  'ageEndYear',
  'contractPremiumBegYear',
  'cirPremium',
  'cirBenefitPayment',
  'cirBenefitPool',
  'cirBenefitMonthsRemaining',
  'totalOutstandingLoanEndYear',
  'totalCashValueEndYear',
  'totalDeathBenefitEndYear',
];

const columnHeaderDef = `<TR class="illustration-header-row">
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>CIR</P></TH>
    <TH><P>Total</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
  </TR>
  <TR class="illustration-header-row">
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>CIR</P></TH>
    <TH><P>Benefit</P></TH>
    <TH><P>Outstanding</P></TH>
    <TH><P>Net</P></TH>
    <TH><P>Net</P></TH>
  </TR>
  <TR class="illustration-header-row">
    <TH><P>&nbsp;</P></TH>
    <TH><P>Age</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>&nbsp;</P></TH>
    <TH><P>CIR</P></TH>
    <TH><P>Benefit</P></TH>
    <TH><P>Months</P></TH>
    <TH><P>Policy</P></TH>
    <TH><P>Cash</P></TH>
    <TH><P>Death</P></TH>
  </TR>
  <TR class="illustration-header-row">
    <TH><P>&nbsp;</P></TH>
    <TH><P>End</P></TH>
    <TH><P>Policy</P></TH>
    <TH><P>CIR</P></TH>
    <TH><P>Benefit</P></TH>
    <TH><P>Pool</P></TH>
    <TH><P>Remaining</P></TH>
    <TH><P>Debt</P></TH>
    <TH><P>Value</P></TH>
    <TH><P>Benefit</P></TH>
  </TR>
  <TR class="td-underline illustration-header-row">
    <TH><P>Year</P></TH>
    <TH><P>Year</P></TH>
    <TH><P>Premium</P></TH>
    <TH><P>Premium</P></TH>
    <TH><P>Payment</P></TH>
    <TH><P>End Year</P></TH>
    <TH><P>End Year</P></TH>
    <TH><P>End Year</P></TH>
    <TH><P>End Year</P></TH>
    <TH><P>End Year</P></TH>
  </TR>`;
